module.exports = __webpack_public_path__ + "static/homepage3-caaf226897d78a1ebcac99f744102eed.jpg";